import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { startOfMonth } from "services/DateService";
import { MSystemGet } from "../common";
import { PageableResponse } from "../PageableResponse";

// 当月取得処理
export const B020020TogetsuYm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  await MSystemGet()
    .then((response) => {
      const firstYmd = startOfMonth(response.data.togetsuYm);
      // 受注日の範囲(開始)初期設定
      methods.setValue("uriYmdFrom", firstYmd);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("uriYmdFrom", "");
    });
};

export type B020020FindRequest = Partial<{
  uriYmdFrom: string;
  uriYmdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  uridenpyoNoFrom: string;
  uridenpyoNoTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  eigyoCd: string;
  shainCdFrom: string;
  shainCdTo: string;
  senyodenpyoNo: string;
  chumonNo: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B020020FindResponse = {
  uriYmd: string;
  uridenpyoNo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  senyodenpyoNo: string;
  chumonNo: string;
  shainNm: string;
  uriKin: string;
  genkaKin: string;
  bumonNm: string;
  arariKin: string;
  uridenpyohakozumiKbn: string;
  shukajokyo: string;
  isSansho: boolean;
};

// 検索メソッド
export const B020020Find = (props: B020020FindRequest) => {
  return RestClient.get<PageableResponse<B020020FindResponse[]>>(
    "b020020/find",
    {
      params: props,
    }
  );
};

export type B020020GetRequest = Partial<{
  uridenpyoNo: string;
}>;

export type B020020GetResponse = {
  isSansho: boolean;
  uridenpyohakoKbn: string;
  uridenpyoNo: string;
  senyodenpyoNo: string;
  juchudenpyoNo: string;
  uriageKbn: string;
  tankaKakeritsu: string;
  zeimarumeKbn: string;
  kinmarumeKbn: string;
  tokuiShokuchiKbn: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  tokuipostCd: string;
  tokuiaddress1: string;
  tokuiaddress2: string;
  tokuitelNo: string;
  tokuifaxNo: string;
  denpyogyosu: string;
  shimeD: string;
  shainCd: string;
  shainNm: string;
  nonyuShokuchiKbn: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  nonyupostCd: string;
  nonyuaddress1: string;
  nonyuaddress2: string;
  nonyutelNo: string;
  nonyufaxNo: string;
  eigyoCd: string;
  uriYmd: string;
  shukaYmd: string;
  hasosakiCd: string;
  hasosakiNm: string;
  hasokbnCd: string;
  hasokbnNm: string;
  seikyushokisaiKbn: string;
  zeiKbn: string;
  assistantCd: string;
  assistantNm: string;
  denpyoshubetsuCd: string;
  denpyoshubetsuNm: string;
  tenpudenpyoCd: string;
  tenpudenpyoNm: string;
  bunrui: string;
  unsogaishaCd: string;
  unsogaishaNm: string;
  bumonCd: string;
  bumonNm: string;
  chumonNo: string;
  denpyoKbn: string;
  ritsu: string;
  hinbetsuNo: string;
  uriageSakuseiKbn: string;
  tantosha: string;
  bikoCd: string;
  biko: string;
  nohinsaki: string;
  uribaNm: string;
  naisen: string;
  ediKbn: string;
  ediMemo: string;
  zeiRitsu: string;
  jodaihyojiKbn: string;
  version: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  seikyushimeNo: string;
  b020020GetMeiResponseList: B020020GetUriageMei[];
};

type B020020GetUriageMei = {
  uridenpyoNo: string;
  urigyoNo: number;
  juchudenpyoNo: string;
  juchugyoNo: string;
  uchiwakeKbn: string;
  kasanfugo: number;
  shohinCd: string;
  janCd: string;
  aiteCd: string;
  shohinNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  urisu: string;
  kanosu: string;
  tenyuryokujodaiKbn: string;
  tenyuryokuuriKbn: string;
  jodaitanka: string;
  uritanka: string;
  setJodaitanka: string;
  toritankaJodaitanka: string;
  toritankaTanka: string;
  tankaTanka: string;
  whJodaitanka: string;
  kakeritsu: string;
  uriKin: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kazeiKbn: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  setshohinKbn: number;
  shokuchiKbn: string;
  whtankaCd: string;
  zaikokanriKbn: string;
  crtDate: string;
  crtshainCd: string;
  b020020GetMeiKoseiResponseList: B020020GetUriageMeiKosei[];
};

type B020020GetUriageMeiKosei = {
  uridenpyoNo: string;
  urigyoNo: number;
  urikoseigyoNo: string;
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  sokoCd: string;
  shohinNm: string;
  janCd: string;
  aiteCd: string;
  koseisu: string;
  hitsuyosu: string;
  kanosu: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  tenyuryokujodaiKbn: string;
  tenyuryokuuriKbn: string;
  jodaitanka: string;
  uritanka: string;
  setJodaitanka: string;
  toritankaJodaitanka: string;
  toritankaTanka: string;
  tankaTanka: string;
  whJodaitanka: string;
  kakeritsu: string;
  uriKin: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: number;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  zaikokanriKbn: string;
  crtDate: string;
  crtshainCd: string;
};

// 売上データ取得メソッド
export const B020020Get = (props: B020020GetRequest) => {
  return RestClient.get<B020020GetResponse>("b020020/get", {
    params: props,
  });
};

export type B020020GetCopyRequest = Partial<{
  uridenpyoNo: string;
  copyKbn: string;
}>;

// 売上データ取得複製メソッド
export const B020020GetCopy = (props: B020020GetCopyRequest) => {
  return RestClient.get<B020020GetResponse>("b020020/get/copy", {
    params: props,
  });
};

export type B020020UridenpyoNo = Partial<{
  uridenpyoNo: string;
}>;

export type B020020DeleteRequest = {
  uridenpyoNoList: B020020UridenpyoNo[];
};

// 売上削除メソッド
export const B020020Delete = (props: B020020DeleteRequest) => {
  return RestClient.delete("b020020/delete", { data: props });
};
